import { render, staticRenderFns } from "./params.vue?vue&type=template&id=31f2549e&scoped=true"
import script from "./params.vue?vue&type=script&lang=js"
export * from "./params.vue?vue&type=script&lang=js"
import style0 from "./params.vue?vue&type=style&index=0&id=31f2549e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2549e",
  null
  
)

export default component.exports